import { Controller } from '@hotwired/stimulus'
import { enter, leave } from "../transition.js"

export default class extends Controller {
  static targets = ["addButton", "form"]
  static values = {
    on: {type: Boolean, default: false},
  }

  // Runs hide animation and then removes element from the page
  toggle() {
    if (this.onValue) {
      this.onValue = false
      this.addButtonTarget.textContent = 'Ajouter un compte'
      this.formTarget.classList.add("d-none")
    } else {
      this.onValue = true
      this.addButtonTarget.textContent = 'Annuler'
      this.formTarget.classList.remove("d-none")
    }
  }
}